import type {
  PatientWithClinicalActivity,
  PublicMember,
  PublicSubscription,
} from '@snootsvet/shared/portal'
import { hasValidAddress } from '@snootsvet/shared/portal'

export type OnboardingIssueType =
  | 'missing_phone'
  | 'unverified_phone'
  | 'invalid_address'
  | 'no_onboarded_pet'

export type PetIssueType = 'incomplete_subscription' | 'lapsed_subscription' | 'no_subscription'

export type MembershipIssueType = 'overdue_invoice' | 'no_bookable_pet'

type AccountIssueType = OnboardingIssueType | PetIssueType | MembershipIssueType

export type AccountIssue = {
  [T in OnboardingIssueType | PetIssueType | MembershipIssueType]: {
    type: T
    title: string
    description?: string
    severity?: 'info' | 'warning'
    action: {
      href: string
      label?: string
    }
  }
}[AccountIssueType]

export type OnboardingIssue = Extract<AccountIssue, { type: OnboardingIssueType }>
export type PetIssue = Extract<AccountIssue, { type: PetIssueType }>
export type MembershipIssue = Extract<AccountIssue, { type: MembershipIssueType }>

export function hasOnboardedPet(patients: PatientWithClinicalActivity[]): boolean {
  return patients.some((pet) => pet.hasSubscription || pet.hasClinicalActivity)
}

export function memberIsOnboarded(
  member: PublicMember,
  patients: PatientWithClinicalActivity[]
): boolean {
  return member.hasStripeAccount || hasOnboardedPet(patients)
}

export function memberCanBookAppointments(member: PublicMember): boolean {
  return hasValidAddress(member) && member.phoneVerified
}

/** The day a membership booked for the future starts, or `null` once it has started. */
export function membershipStartsOn(subscription: PublicSubscription | null | undefined) {
  return subscription?.status === 'scheduled' ? subscription.effectiveStartDate : null
}
